import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import * as Icons from "lucide-react";
import { Recycle } from "lucide-react";
import { LoadingState } from "@/components/States";
import api from "@/lib/api";

export default function Categories() {
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    api.get("/categories").then(({ data }) => setCategories(data.items)).finally(() => setLoading(false));
  }, []);

  if (loading) return <LoadingState />;

  return (
    <div className="mx-auto max-w-7xl px-6 py-10">
      <h1 className="font-display text-3xl font-extrabold tracking-tight text-slate-900">Tüm Kategoriler</h1>
      <p className="mt-1 text-slate-500">İhtiyacınıza uygun kategoriyi seçin</p>
      <div className="mt-8 grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
        {categories.map((cat) => {
          const Icon = Icons[cat.icon] || Recycle;
          return (
            <div key={cat.slug} className="rounded-xl border border-slate-200 bg-white p-5">
              <Link to={`/ilanlar?category=${cat.slug}`} data-testid={`cat-page-${cat.slug}`} className="flex items-center gap-3">
                <span className="flex h-11 w-11 items-center justify-center rounded-lg bg-emerald-50 text-emerald-700"><Icon size={22} /></span>
                <h3 className="font-display text-lg font-bold text-slate-900 hover:text-emerald-700">{cat.name}</h3>
              </Link>
              {cat.subcategories?.length > 0 && (
                <div className="mt-3 flex flex-wrap gap-1.5">
                  {cat.subcategories.map((sub) => (
                    <Link key={sub} to={`/ilanlar?category=${cat.slug}`}
                      className="rounded-full bg-slate-100 px-2.5 py-1 text-xs text-slate-600 hover:bg-emerald-100 hover:text-emerald-700">{sub}</Link>
                  ))}
                </div>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
}
